import axios from "axios";

export const apiSmsLogsGet = async (siteId, options = {}) => {
	const { skip = 0, take = 25, search = null, dateFrom = null, dateTo = null } = options;

	const result = await axios({
		method: "get",
		url: "v2/SmsLogs",
		params: {
			SiteId: siteId,
			skip,
			take,
			search: search || undefined,
			// The pickers hand over plain dates. The backend filter is inclusive on both ends, so the end
			// of the day is what makes "to 12 Aug" include the messages sent on 12 August.
			dateFrom: dateFrom ? `${dateFrom}T00:00:00` : undefined,
			dateTo: dateTo ? `${dateTo}T23:59:59` : undefined,
		},
		headers: {
			// Surface a slow or failed log read inline in the dialog rather than throwing the user out to
			// /errors/500 — the packages beside it are still readable and still correct.
			backgroundTaskAllowFail: true,
		},
	});

	return result.data;
};
